import { store } from '../../store';
import {
  appRateStatuses,
  SHOW_APP_RATE_AFTER_DAYS,
  subscriptionStatuses
} from '../constants';

export class ConditionHelper {
  constructor() {
    this.store = store;
    this.store.subscribe(() => {
      this.state = this.store.getState();
    });
  }

  isUserLogged() {
    const { auth } = this.state;
    return auth.loggedIn;
  }

  isUserSubscriber() {
    const { auth } = this.state;
    return (
      auth.user &&
      auth.user.subscription_status !==
        subscriptionStatuses.NO_VALID_SUBSCRIPTION
    );
  }

  userLoggedAndNotSeenWelcomeDialog() {
    const { auth } = this.state;
    return (
      this.isUserLogged() &&
      auth.user &&
      (!auth.user.dismissed_welcome_dialogue && !auth.user.is_premium)
    );
  }

  userLoggedAndAbleToRateTheApp() {
    const { auth } = this.state;
    const timestampDaysBefore =
      new Date().getTime() - SHOW_APP_RATE_AFTER_DAYS * 24 * 60 * 60 * 1000;
    return (
      this.isUserLogged() &&
      auth.user &&
      auth.user.app_rating_status === appRateStatuses.NOT_PROMPTED &&
      new Date(auth.user.date_joined).getTime() < timestampDaysBefore
    );
  }
}

export default new ConditionHelper();



// WEBPACK FOOTER //
// ./src/utils/helpers/ConditionHelper.js